import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/atoms/Button";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("Atlas UI render error", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="h-full w-full flex items-center justify-center p-12">
        <div className="glass rounded-lg max-w-md w-full p-6 text-center">
          <h2 className="text-lg font-semibold text-bridge-fg">Something went sideways</h2>
          <p className="mt-2 text-sm text-bridge-muted">{this.state.error.message}</p>
          <div className="mt-4 flex justify-center gap-2">
            <Button variant="primary" onClick={this.reset}>Retry</Button>
          </div>
        </div>
      </div>
    );
  }
}